import type { SelectOption } from "@/models/SelectOption";
import type { SelectOptionGroup } from "@/models/SelectOptionGroup";

export type AvailableOptionTypes<
	T extends boolean | string | number | symbol = string,
> = Record<string, T> | (SelectOption | SelectOptionGroup | string | number)[];

function processOption(opt: string | number) {
	return { label: String(opt), value: opt };
}

export function useOptionsFlatMap(opts: AvailableOptionTypes) {
	return mapOpts(opts, true);
}

export function useOptionsMap(opts: AvailableOptionTypes) {
	return mapOpts(opts, false);
}

function mapOpts(opts: AvailableOptionTypes, mapFlat: true): SelectOption[];
function mapOpts(
	opts: AvailableOptionTypes,
	mapFlat: false,
): (SelectOption | SelectOptionGroup)[];
function mapOpts(
	opts: AvailableOptionTypes,
	mapFlat: boolean,
): (SelectOption | SelectOptionGroup)[] {
	if (Array.isArray(opts)) {
		if (mapFlat) {
			return opts.flatMap((opt): SelectOption | SelectOption[] => {
				if (typeof opt !== "object") {
					return processOption(opt);
				}
				if ("options" in opt) {
					return opt.options;
				}
				return opt;
			});
		}
		return opts.map((opt) => {
			if (typeof opt !== "object") {
				return processOption(opt);
			}

			return opt;
		});
	}
	return Object.entries(opts).map(
		([key, value]): SelectOption => ({
			label: String(value),
			value: key,
		}),
	);
}
